
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "width": "52px",
    "height": "45px",
    "viewBox": "0 0 52 45",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink"
  },
  "children": [
    {
      "tag": "defs",
      "children": [
        {
          "tag": "filter",
          "attrsMap": {
            "x": "-9.4%",
            "y": "-6.2%",
            "width": "118.8%",
            "height": "122.5%",
            "filterUnits": "objectBoundingBox",
            "id": "filter-1"
          },
          "children": [
            {
              "tag": "feOffset",
              "attrsMap": {
                "dx": "0",
                "dy": "1",
                "in": "SourceAlpha",
                "result": "shadowOffsetOuter1"
              }
            },
            {
              "tag": "feGaussianBlur",
              "attrsMap": {
                "stdDeviation": "1",
                "in": "shadowOffsetOuter1",
                "result": "shadowBlurOuter1"
              }
            },
            {
              "tag": "feColorMatrix",
              "attrsMap": {
                "values": "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.15 0",
                "type": "matrix",
                "in": "shadowBlurOuter1",
                "result": "shadowMatrixOuter1"
              }
            },
            {
              "tag": "feMerge",
              "children": [
                {
                  "tag": "feMergeNode",
                  "attrsMap": {
                    "in": "shadowMatrixOuter1"
                  }
                },
                {
                  "tag": "feMergeNode",
                  "attrsMap": {
                    "in": "SourceGraphic"
                  }
                }
              ]
            }
          ]
        },
        {
          "tag": "rect",
          "attrsMap": {
            "id": "path-2",
            "x": "0",
            "y": "0",
            "width": "48",
            "height": "40",
            "rx": "4"
          }
        },
        {
          "tag": "filter",
          "attrsMap": {
            "x": "-4.2%",
            "y": "-2.5%",
            "width": "108.3%",
            "height": "110.0%",
            "filterUnits": "objectBoundingBox",
            "id": "filter-4"
          },
          "children": [
            {
              "tag": "feOffset",
              "attrsMap": {
                "dx": "0",
                "dy": "1",
                "in": "SourceAlpha",
                "result": "shadowOffsetOuter1"
              }
            },
            {
              "tag": "feGaussianBlur",
              "attrsMap": {
                "stdDeviation": "0.5",
                "in": "shadowOffsetOuter1",
                "result": "shadowBlurOuter1"
              }
            },
            {
              "tag": "feColorMatrix",
              "attrsMap": {
                "values": "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0",
                "type": "matrix",
                "in": "shadowBlurOuter1"
              }
            }
          ]
        }
      ]
    },
    {
      "tag": "g",
      "attrsMap": {
        "id": "darkModeIcon",
        "width": "48",
        "height": "40",
        "stroke": "none",
        "stroke-width": "1",
        "fill": "none",
        "fill-rule": "evenodd"
      },
      "children": [
        {
          "tag": "g",
          "attrsMap": {
            "id": "setting-copy-2",
            "width": "48",
            "height": "40",
            "transform": "translate(-1190.000000, -136.000000)"
          },
          "children": [
            {
              "tag": "g",
              "attrsMap": {
                "id": "Group-8",
                "width": "48",
                "height": "40",
                "transform": "translate(1167.000000, 0.000000)"
              },
              "children": [
                {
                  "tag": "g",
                  "attrsMap": {
                    "id": "Group-5-Copy-5",
                    "filter": "url(#filter-1)",
                    "transform": "translate(25.000000, 137.000000)"
                  },
                  "children": [
                    {
                      "tag": "mask",
                      "attrsMap": {
                        "id": "mask-3",
                        "fill": "white"
                      },
                      "children": [
                        {
                          "tag": "use",
                          "attrsMap": {
                            "xlink:href": "#path-2"
                          }
                        }
                      ]
                    },
                    {
                      "tag": "g",
                      "attrsMap": {
                        "id": "Rectangle-18"
                      },
                      "children": [
                        {
                          "tag": "use",
                          "attrsMap": {
                            "fill": "black",
                            "fill-opacity": "1",
                            "filter": "url(#filter-4)",
                            "xlink:href": "#path-2"
                          }
                        },
                        {
                          "tag": "use",
                          "attrsMap": {
                            "fill": "#303648",
                            "fill-rule": "evenodd",
                            "xlink:href": "#path-2"
                          }
                        }
                      ]
                    },
                    {
                      "tag": "rect",
                      "attrsMap": {
                        "id": "Rectangle-11",
                        "fill": "#303648",
                        "mask": "url(#mask-3)",
                        "x": "0",
                        "y": "0",
                        "width": "48",
                        "height": "10"
                      }
                    },
                    {
                      "tag": "rect",
                      "attrsMap": {
                        "id": "Rectangle-18",
                        "fill": "#303648",
                        "mask": "url(#mask-3)",
                        "x": "0",
                        "y": "0",
                        "width": "16",
                        "height": "40"
                      }
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
})
    }
  